import { Skeleton } from "@/components/ui/skeleton";

export function PartnerSidebarSkeleton() {
  return (
    <div className="w-full mt-[2.88rem]">
      {/* Logo */}
      <div className="mb-[1.88rem]">
        <Skeleton className="h-[6.88rem] w-[6.88rem] rounded-full" />
      </div>

      {/* Verified badge and name */}
      <div className="mb-[1.88rem]">
        <div className="flex flex-row items-center mb-2">
          <Skeleton className="w-[1.13rem] h-[1.13rem] rounded-full mr-2" />
          <Skeleton className="h-3 w-16" />
        </div>
        <Skeleton className="h-10 w-48" />
      </div>

      {/* Stats grid */}
      <div className="grid grid-cols-3 gap-4 mb-[1.88rem]">
        <div className="flex flex-col">
          <Skeleton className="h-8 w-16 mb-1" />
          <Skeleton className="h-4 w-20" />
        </div>
        <div className="flex flex-col">
          <Skeleton className="h-8 w-16 mb-1" />
          <Skeleton className="h-4 w-20" />
        </div>
        <div className="flex flex-col">
          <Skeleton className="h-8 w-16 mb-1" />
          <Skeleton className="h-4 w-20" />
        </div>
      </div>

      {/* Join button */}
      <Skeleton className="h-12 w-full rounded-xl mb-[1.88rem]" />

      {/* Description */}
      <div className="mb-[1.88rem]">
        <Skeleton className="h-4 w-full mb-2" />
        <Skeleton className="h-4 w-full mb-2" />
        <Skeleton className="h-4 w-3/4" />
      </div>

      {/* Social links */}
      <div className="flex flex-row flex-wrap gap-2">
        <Skeleton className="h-10 w-10 rounded-full" />
        <Skeleton className="h-10 w-10 rounded-full" />
        <Skeleton className="h-10 w-10 rounded-full" />
        <Skeleton className="h-10 w-10 rounded-full" />
      </div>
    </div>
  );
}
